import { render } from "./JobSeekerPreviousApplications.vue?vue&type=template&id=89df01da"
import script from "./JobSeekerPreviousApplications.vue?vue&type=script&lang=js"
export * from "./JobSeekerPreviousApplications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__